import React from "react";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Grid } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";
import PageHeader from "../../../components/PageHeader";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
  root: {
    margin: 0,
    width: "100%",
  },
  left: {
    paddingLeft: "0!important",
  },
  right: {
    [theme.breakpoints.up("sm")]: {
      paddingRight: "0!important",
    },
  },
  header: {
    marginTop: 0,
  },
  title: {
    fontSize: 56,
    marginBottom: 20,
    lineHeight: "60px",
    fontWeight: "bold",
    color: theme.palette.getContrastText(theme.palette.primary.dark),
  },
  caption: {
    fontSize: 16,
    marginBottom: 70,
    lineHeight: "26px",
    fontWeight: "bold",
    color: theme.palette.getContrastText(theme.palette.primary.dark),
  },
  paper: {
    padding: 35,
    [theme.breakpoints.down("sm")]: {
      padding: 0,
    },
  },
  videoThumbnailContainer: {
    borderRadius: 5,
    width: 267,
    height: 146,
    backgroundSize: "cover",
    boxShadow: "0 29px 55px 0 rgba(0, 0, 0, 0.69)",
  },
}));

export default function AuthTwoColumnedPage({
  title,
  caption,
  boxTitle,
  boxCaption,
  videoUrl,
  children,
}: {
  title: string;
  caption?: string;
  boxTitle: string;
  boxCaption?: string;
  videoUrl?: string;
  children: React.ReactElement;
}) {
  const classes = useStyles();

  return (
    <Container className={classes.container}>
      <Grid container spacing={5} className={classes.root}>
        <Hidden smDown>
          <Grid item md={6} sm={12} xs={12} className={classes.left}>
            <Typography variant={"h1"} className={classes.title}>
              {title}
            </Typography>
            {caption && (
              <Typography variant={"body1"} className={classes.caption}>
                {caption}
              </Typography>
            )}
            {videoUrl && (
              <iframe
                className={classes.videoThumbnailContainer}
                src={videoUrl}
                title={"Auth video WorldEd"}
                frameBorder="0"
                allow="autoplay; fullscreen"
                allowFullScreen
              ></iframe>
            )}
          </Grid>
        </Hidden>
        <Grid item md={6} sm={12} xs={12} className={classes.right}>
          <Paper elevation={0} className={classes.paper}>
            <PageHeader
              title={boxTitle}
              className={classes.header}
              subtitle={boxCaption}
              disableBackButton
            />
            {children}
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
